import React from "react";
import { Accordion, Card } from "react-bootstrap";

import ModalInfo from "../../ModalInfo";

class Page2 extends React.Component {
  state = {
    visible: true,
    age: null,
    modalShow: true,
    modalTitle: "INSTRUCTIONS",
    modalContent: (
      <div>
        <p>
          In his book titled{" "}
          <a
            target="_blank"
            href="https://bath-ac-primo.hosted.exlibrisgroup.com/primo-explore/fulldisplay?docid=44BAT_ALMA_DS2130486310002761&context=L&vid=44BAT_VU1&lang=en_US&search_scope=LSCOP_44BAT_LOCAL&adaptor=Local%20Search%20Engine&tab=books&query=any,contains,Daniel%20Goleman&pfilter=pfilter,exact,books&offset=0&pcAvailability=false"
          >
            <i>Emotional Intelligence - Why It Can Matter More Than IQ</i>
          </a>
          , Daniel Goleman, an American psychologist, developed a framework of
          five elements that define emotional intelligence. Click on each
          element to discover what it means.
        </p>
      </div>
    ),
  };

  checkPageVisibility(pageNum) {
    if (pageNum == 2) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    let modalClose = () => this.setState({ modalShow: false });

    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0  d-md-block">Emotional Intelligence</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
              <ul className="nav navbar-nav ml-auto">
                <div>
                  <i
                    className="fas fa-info-square fa-3x"
                    onClick={() =>
                      this.setState({
                        modalShow: true,
                        modalTitle: "INSTRUCTIONS",
                        modalContent: (
                          <div>
                            <p>
                              In his book titled{" "}
                              <a
                                target="_blank"
                                href="https://bath-ac-primo.hosted.exlibrisgroup.com/primo-explore/fulldisplay?docid=44BAT_ALMA_DS2130486310002761&context=L&vid=44BAT_VU1&lang=en_US&search_scope=LSCOP_44BAT_LOCAL&adaptor=Local%20Search%20Engine&tab=books&query=any,contains,Daniel%20Goleman&pfilter=pfilter,exact,books&offset=0&pcAvailability=false"
                              >
                                <i>
                                  Emotional Intelligence - Why It Can Matter
                                  More Than IQ
                                </i>
                              </a>
                              , Daniel Goleman, an American psychologist,
                              developed a framework of five elements that define
                              emotional intelligence. Click on each element to
                              discover what it means.
                            </p>
                          </div>
                        ),
                      })
                    }
                  ></i>
                </div>
              </ul>
            </nav>
            <br />
            <br />

            <div className="container">
              <div id="moduleContentText_2">
                <div
                  className="card mb-4 box-shadow h-100"
                  id="pageContent_2"
                  style={{ cursor: "pointer", textAlign: "left" }}
                >
                  <Accordion defaultActiveKey="0">
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="0">
                        1. Self-awareness
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          People with high emotional intelligence are usually
                          very self-aware. They are willing to take an honest
                          look at themselves. They know their strengths and
                          weaknesses, and they work on these areas so they can
                          perform better. Many people believe that this
                          self-awareness is the most important part of emotional
                          intelligence.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="1">
                        2. Self-regulation
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="1">
                        <Card.Body>
                          This is the ability to control emotions and impulses.
                          People who self-regulate typically don't allow
                          themselves to become too angry or jealous, and they
                          don't make impulsive, careless decisions. They think
                          before they act. Characteristics of self-regulation
                          are thoughtfulness, comfort with change, integrity and
                          the ability to say no.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="2">
                        3. Motivation
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="2">
                        <Card.Body>
                          People with a high degree of emotional intelligence
                          are usually motivated. They're willing to defer
                          immediate results for long-term success. They're
                          highly productive, love a challenge, and are very
                          effective in whatever they do.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="3">
                        4. Empathy
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="3">
                        <Card.Body>
                          This is perhaps the second-most important element of
                          emotional intelligence. Empathy is the ability to
                          identify with and understand the wants, needs, and
                          viewpoints of those around you. People with empathy
                          are good at recognising the feelings of others, even
                          when those feelings may not be obvious. As a result,
                          empathetic people are usually excellent at managing
                          relationships, listening and relating to others.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="4">
                        5. Social Skills
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="4">
                        <Card.Body>
                          It's usually easy to talk to and like people with good
                          social skills, another sign of high emotional
                          intelligence. Those with strong social skills are
                          typically team players. Rather than focus on their own
                          success first, they help others develop and shine.
                          They can manage disputes, are excellent communicators,
                          and are masters at building and maintaining
                          relationships.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
              </div>
            </div>

            <br />
            <br />
            <div className="container">
              <div id="moduleContentText_2">
                <div className="card mb-4 box-shadow h-100" id="pageContent_2">
                  <ul className="list-group list-group-flush text-dark ">
                    <li
                      className="list-group-item"
                      style={{
                        padding: "3px 10px",
                        backgroundColor: "#2bc7ee",
                      }}
                    ></li>
                    <li className="list-group-item  form-card-2 ">
                      <p id="moduleContentText">
                        As you've probably determined, emotional intelligence
                        can be a key to success in your life – especially in
                        your career. The ability to manage people and
                        relationships is very important in all leaders, so
                        developing and using your emotional intelligence can be
                        a good way to show others the leader inside of you.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <ModalInfo
              show={this.state.modalShow}
              onHide={modalClose}
              title={this.state.modalTitle}
              content={this.state.modalContent}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page2;
